'use client';
import Image, { ImageProps } from 'next/image';
import { useState } from 'react';
import loader2 from '/public/assets/loader2.gif';

const LoaderImage = (props: ImageProps) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => {
    setLoading(false);
  };

  return (
    <div className="relative w-full">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 dark:bg-gray-700">
          <Image src={loader2} alt="loader2" className="w-auto md:w-52" />
        </div>
      )}

      <Image
        {...props}
        // width={props.width || 340}
        // height={props.height || 500}
        fill
        loader={({ src, width, quality }) => `${src}?w=${width}&q=${quality || 75}`}
        className={`${
          loading ? 'opacity-0 blur-sm' : 'object-cover opacity-100 blur-none transition-all duration-1000'
        } ${props.className || ''}`}
        alt={props.alt || 'Image'}
        quality={100}
        unoptimized
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default LoaderImage;
